// Display-only title normalization; never write the result back.
const KEEP_UPPER = new Set(["SQ", "CZ", "VVS", "VS", "SI", "GRA", "GIA", "IGI", "DEF", "HPHT", "CVD", "LGD", "S925", "925", "XS", "XL", "XXL"]);

const fixWord = (w) => {
    if (!w || /\d/.test(w) || /[a-z]/.test(w) || !/[A-Z]/.test(w)) return w;
    if (KEEP_UPPER.has(w.replace(/[^A-Z0-9]/g, "")) || w.replace(/[^A-Z]/g, "").length <= 2) return w;
    return w.charAt(0) + w.slice(1).toLowerCase();
};

export const formatProductName = (name) =>
    (name || "").split(/(\s+|[-/()])/).map(fixWord).join("");
